import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    QueryList,
    ViewChildren,
} from '@angular/core';
import {DemandeModif} from './demande-modif.model';
import {DemandeModifService} from './demande-modif.service';
import {ConfirmationService} from 'primeng/components/common/api';
import {AlertService, JhiLanguageService} from 'ng-jhipster';
import {TranslateService} from 'ng2-translate';
import {Editor} from 'primeng/primeng';
import {JhiAlertComponent, Principal} from '../../../shared';
import {DatePipe} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-demande-modif-component',
    templateUrl: 'demande-modif.component.html'
})
export class DemandeModifComponent implements OnChanges, AfterViewInit {

    @Input() entityId: number;
    @Input() entityType: string;

    @Input() demandeModifs: DemandeModif[];
    @Output() demandeModifsChange: EventEmitter<DemandeModif[]> = new EventEmitter();
    @Input() currentLang: string;
    @Input() disabled: boolean;

    @ViewChildren(Editor) editorList: QueryList<Editor>;
    private login: string;

    constructor(
        private confirmationService: ConfirmationService,
        private demandeModifService: DemandeModifService,
        private alertService: AlertService,
        private translateService: TranslateService,
        private principal: Principal,
        private datePipe: DatePipe,
        private jhiLanguageService: JhiLanguageService,
        public activeModal: NgbActiveModal,

    ) {
    }


    ngOnInit() {
        this.principal.getIdentityLogin().then(login => {
            this.login = login.toString();
        });
    }


    ngAfterViewInit() {
        // les <p-dialog [disabled]=true> ne fonctionnent pas, contournement ci après
        if (this.disabled) {
            this.editorList.forEach(
                editor => {
                    editor.quill.disable();
                });
        }
    }

    ngOnChanges() {
    }

    addDemandeModif() {
        if (!this.demandeModifs) {
            this.demandeModifs = [];
        }
        this.demandeModifs.push(this.newDemandeModif());
        this.demandeModifsChange.emit(this.demandeModifs);
    }

    clearDemandeModif(index) {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.formation.delete.demandeModifComplementaire.demandeModif'),
            header: this.translateService.instant('cadensApp.formation.delete.demandeModifComplementaire.title'),
            accept: () => {
                if (this.demandeModifs[index].id != null) {
                    this.demandeModifService.delete(this.demandeModifs[index].id).subscribe(() => {
                        this.demandeModifs.splice(index, 1);
                        this.demandeModifsChange.emit(this.demandeModifs);
                    }, error => {
                        this.alertService.error(error.message, null, null);
                    });
                } else {
                    this.demandeModifs.splice(index, 1);
                    this.demandeModifsChange.emit(this.demandeModifs);
                }
            },
            reject: () => {
            }
        });
    }

    private newDemandeModif(): DemandeModif {
        let q: DemandeModif = new DemandeModif();
        q.entityId = this.entityId;
        q.entityType = this.entityType;
        /*
                q.createdDate = new Date();
                q.createdBy = this.login;
        */
        return q;
    }

    isPasDeModification() {
        if (this.disabled) {
            return this.disabled;
        }
        return null;
    }

    formatDate(date: Date): string {
        let dateFormat = 'yyyy-MM-dd';

        return (this.datePipe.transform(date, dateFormat));
    }

    deleteDemandeModif(index) {
        this.confirmationService.confirm({
            message: this.translateService.instant('cadensApp.demandeModif.delete.demandeModif.question'),
            header: this.translateService.instant('cadensApp.demandeModif.delete.demandeModif.title'),
            key: 'deleteDemandModif',
            accept: () => {
                if (this.demandeModifs[index].id != null) {
                    this.demandeModifService.delete(this.demandeModifs[index].id).subscribe(() => {
                        this.demandeModifs.splice(index, 1);
                        this.demandeModifsChange.emit(this.demandeModifs);
                        this.activeModal.dismiss();
                    }, error => {
                        JhiAlertComponent.onError(this.alertService, error);
                    });
                } else {
                    this.demandeModifs.splice(index, 1);
                    this.demandeModifsChange.emit(this.demandeModifs);
                }
            },
            reject: () => {
            }
        });
    }


    buildTitreDemandeModif(demandeModif: DemandeModif) {
        if (demandeModif.lastModifiedBy != null && demandeModif.lastModifiedDate != null) {
            return this.translateService.instant(
                'cadensApp.demandeModif.titreAvecModification',
                {
                    'titre': demandeModif.titre,
                    'createdBy': demandeModif.createdBy,
                    'createdDate': this.formatDate(demandeModif.createdDate),
                    'modifiedBy': demandeModif.lastModifiedBy,
                    'modifiedDate': this.formatDate(demandeModif.lastModifiedDate)
                }
            );
        } else {
            if (demandeModif.createdBy != null && demandeModif.createdDate != null) {

                return this.translateService.instant(
                    'cadensApp.demandeModif.titreAvecCreation',
                    {
                        'titre': demandeModif.titre,
                        'createdBy': demandeModif.createdBy,
                        'createdDate': this.formatDate(demandeModif.createdDate)
                    }
                );
            } else {
                return this.translateService.instant(
                    'cadensApp.demandeModif.titre',
                    {
                        'titre': demandeModif.titre,
                        'createdBy': demandeModif.createdBy,
                        'createdDate': this.formatDate(demandeModif.createdDate)
                    }
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/demande-modif/demande-modif.component.ts